import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useGame } from '../context/GameContext';
import { currentWeekKey, seedForWeekly } from '../game/profile';
import { mutatorForWeek } from '../game/depth';
import { ArrowLeft, Play, Trophy, Calendar, Zap } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Weekly() {
  const { startWeeklyRun, goToMenu } = useGame();
  const [top, setTop] = useState([]);
  const [loading, setLoading] = useState(true);
  const wk = currentWeekKey();
  const seed = seedForWeekly();
  const mutator = mutatorForWeek(wk);

  useEffect(() => {
    axios.get(`${API}/leaderboard/weekly/${wk}?limit=25`)
      .then(r => setTop(r.data || []))
      .catch(() => setTop([]))
      .finally(() => setLoading(false));
  }, [wk]);

  return (
    <div className="min-h-screen w-full px-6 py-6 max-w-5xl mx-auto">
      <div className="flex items-center justify-between">
        <button className="brutal-btn text-sm" onClick={goToMenu} data-testid="weekly-back-button">
          <ArrowLeft size={16} /> BACK
        </button>
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.4em] text-[color:var(--text-dim)]">
          <Calendar size={14}/> {wk}
        </div>
      </div>

      <h1 className="mt-4 font-display text-5xl sm:text-7xl font-black uppercase text-[color:var(--neon)] text-center">WEEKLY SLOP</h1>
      <div className="mt-2 text-center text-sm uppercase tracking-widest text-[color:var(--text-dim)]">
        one seed per week. run it as much as you want. best score sticks.
      </div>

      <div className="mt-6 brutal-border p-6 bg-[#0a0a0a] flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-[color:var(--text-dim)]">THIS WEEK'S SEED</div>
          <div className="font-display text-5xl font-black text-[color:var(--neon)] tracking-widest" data-testid="weekly-seed">{seed}</div>
        </div>
        <button className="brutal-btn text-lg" onClick={() => startWeeklyRun(seed)} data-testid="start-weekly-button">
          <Play size={18} /> RUN IT
        </button>
      </div>

      {/* v0.8: Weekly Mutator Banner */}
      <div className="mt-4 brutal-border-pink p-5 bg-[#160a10] flex items-center gap-4" data-testid="weekly-mutator">
        <div className="text-6xl">{mutator.art}</div>
        <div className="flex-1">
          <div className="text-xs uppercase tracking-widest text-[color:var(--pink)] flex items-center gap-2">
            <Zap size={12} /> THIS WEEK'S MUTATOR
          </div>
          <div className="font-display font-black text-3xl uppercase text-[color:var(--pink)]" data-testid="mutator-name">{mutator.name}</div>
          <div className="text-sm text-[color:var(--text)]">{mutator.desc}</div>
        </div>
      </div>

      <div className="mt-10">
        <div className="flex items-center gap-2 text-[color:var(--pink)] mb-3">
          <Trophy size={18}/> <span className="font-display font-black uppercase text-lg">WEEKLY TOP</span>
        </div>
        {loading && <div className="text-[color:var(--text-dim)] text-sm">Loading...</div>}
        {!loading && top.length === 0 && (
          <div className="text-center py-10 brutal-border-dim text-[color:var(--text-dim)] uppercase text-sm">NO RUNS THIS WEEK YET. LEGENDS ARE MADE HERE.</div>
        )}
        <div className="flex flex-col gap-2" data-testid="weekly-leaderboard">
          {top.map((e, i) => (
            <div key={e.id} className={`flex items-center justify-between px-4 py-2 ${i === 0 ? 'brutal-border-pink' : 'brutal-border-dim'} bg-[#0a0a0a]`}
              data-testid={`weekly-entry-${i}`}>
              <div className="flex items-center gap-4">
                <div className="font-display font-black text-xl w-8 text-[color:var(--neon)]">#{i+1}</div>
                <div className="font-display font-black uppercase">{e.player_name}</div>
                {e.ascension > 0 && <span className="brutal-border-pink px-2 py-0.5 text-[10px] font-bold text-[color:var(--pink)]">A{e.ascension}</span>}
              </div>
              <div className="flex items-center gap-6 text-xs uppercase font-mono">
                <span className="text-[color:var(--text-dim)]">FL <span className="text-white">{e.floor_reached}</span></span>
                <span className="font-display text-xl font-black text-[color:var(--neon)] w-24 text-right">{e.score}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
